import {
  YEAR_CHANGE,
  DATAVIEW_CHANGE,
  CHARACTERISTIC_TOGGLE,
  TABLE_COLUMN_ORDER_CHANGE,
} from 'Config/types';

export default function tableReducer(state = {}, { type = '', payload } = {}) {
  switch (type) {
    case YEAR_CHANGE: {
      const { indicator: id, year, mega: isMega = false } = payload;
      if (isMega) {
        const mega = state.mega.map((item) => ({
          ...item,
          active: id === item.id ?
            { ...item.active, year } :
            item.active,
        }));
        const indicators = state.indicators.map((indicator) => ({
          ...indicator,
          active: id === indicator.parent ?
            { ...indicator.active, year } :
            indicator.active,
        }));
        return { ...state, mega, indicators };
      }
      const indicators = state.indicators.map((indicator) => ({
        ...indicator,
        active: id === indicator.id ?
          { ...indicator.active, year } :
          indicator.active,
      }));
      return { ...state, indicators };
    }
    case DATAVIEW_CHANGE: {
      const { indicator: id, dataView, mega: isMega = false } = payload;
      if (isMega) {
        const mega = state.mega.map((item) => ({
          ...item,
          active: id === item.id ?
            { ...item.active, dataView } :
            item.active,
        }));
        const indicators = state.indicators.map((indicator) => ({
          ...indicator,
          active: id === indicator.parent ?
            { ...indicator.active, dataView } :
            indicator.active,
        }));
        return { ...state, mega, indicators };
      }
      const indicators = state.indicators.map((indicator) => ({
        ...indicator,
        active: id === indicator.id ?
          { ...indicator.active, dataView } :
          indicator.active,
      }));
      return { ...state, indicators };
    }
    case CHARACTERISTIC_TOGGLE: {
      const { row: id } = payload;
      const rows = state.rows.map((row) => ({
        ...row,
        visible: row.id === id ? !row.visible : row.visible,
      }));
      return { ...state, rows };
    }
    case TABLE_COLUMN_ORDER_CHANGE: {
      const { columnState } = payload;
      return { ...state, columnState };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/table.js